import React, { useEffect, useState } from 'react';
import { Rows3, Rows4 } from 'lucide-react';
import { Button } from '../ui/button';
import { useAuth } from '../../context/AuthContext';

const KEY = (uid) => `compact_tables_${uid}`;

export const CompactTablesToggle = () => {
  const { user, api } = useAuth();
  const uid = user?.user_id;
  const saved = user?.preferences?.ui_preferences?.compact_tables;
  const [compact, setCompact] = useState(false);

  useEffect(() => {
    if (!uid) return;
    const local = localStorage.getItem(KEY(uid));
    setCompact(typeof saved === 'boolean' ? saved : local === '1');
  }, [uid, saved]);

  useEffect(() => {
    document.body.classList.toggle('compact-tables', compact);
    return () => document.body.classList.remove('compact-tables');
  }, [compact]);

  const toggle = () => {
    const next = !compact;
    setCompact(next);
    localStorage.setItem(KEY(uid), next ? '1' : '0');
    api.patch('/auth/preferences', {
      ui_preferences: { ...(user?.preferences?.ui_preferences || {}), compact_tables: next },
    }).catch(() => {});
  };

  if (!uid) return null;
  return (
    <Button
      variant="ghost"
      size="icon"
      onClick={toggle}
      className={`hover:text-white ${compact ? 'text-sky-400' : 'text-slate-400'}`}
      data-testid="compact-tables-toggle"
      aria-pressed={compact}
      title={compact ? 'Compact tables: on (click for normal spacing)' : 'Compact tables: off (click to fit more rows and columns)'}
    >
      {compact ? <Rows4 className="h-5 w-5" /> : <Rows3 className="h-5 w-5" />}
    </Button>
  );
};
